import { makeStyles } from 'tss-react/mui';

export const useContactPageStyles = makeStyles()(() => ({
  root: {
    height: '90vh',
    display: 'flex',
    width: '100%',
  },
}));
